import { StatusCodes } from 'http-status-codes';
import { initialPage } from '../../reducers/utils/reducerUtils';
import { GLOBALS } from './actionCases';

export const orderPage = (res, params) => {
	// Consistantly order returned page by identifier
	let orderedPageIdentifiers = [];
	let orderedPage = [];
	for (const item of res.data[params.pageName]) {
		orderedPageIdentifiers.push(JSON.stringify(item.identifier));
	}
	orderedPageIdentifiers = orderedPageIdentifiers.sort();
	for (const orderedPageIdentifier of orderedPageIdentifiers) {
		const foundItem = res.data[params.pageName].find((item) => JSON.stringify(item.identifier) === orderedPageIdentifier);
		orderedPage.push(foundItem);
	}
	return orderedPage;
};

export const actionDefaults = {
	getPage: (CASES, res, params) => ((res.status === StatusCodes.OK && res.data
		&& res.data[params.pageName] && res.data[params.pageName].length) ? {
			type: CASES.GET_PAGE,
			[params.pageName]: orderPage(res, params),
			page: res.data.page,
			pageSize: res.data.pageSize,
			totalItems: res.data.totalItems,
			lastEvaluatedKey: res.data.lastEvaluatedKey,
			previousEvaluatedKey: res.data.previousEvaluatedKey,
		} : {
			type: CASES.CLEAR_PAGES,
			[params.pageName]: [],
			...initialPage,
		}
	),
	getItem: (CASES, res, params) => ((res.status === StatusCodes.OK) ? {
		type: CASES.GET,
		[params.itemName]: res.data,
	} : {
		type: CASES.CLEAR_ITEM,
		[params.itemName]: null,
	}
	),
	postItem: (CASES, res, params) => ((res.status === StatusCodes.OK) ?
		{
			type: CASES.POST,
			[params.itemName]: res.data[params.itemName],
		} : {
			type: GLOBALS.DEAD_END
		}
	),
	postInviteUserTo: (CASES, res, params) => ((res.status === StatusCodes.OK) ?
		{
			type: CASES.POST_INVITE_USER_TO,
			[params.itemName]: res.data[params.itemName],
		} : {
			type: GLOBALS.DEAD_END
		}
	),
	putItem: (CASES, res, params) => ((res.status === StatusCodes.OK) ?
		{
			type: CASES.PUT,
			[params.itemName]: res.data[params.itemName],
		} : {
			type: GLOBALS.DEAD_END
		}
	),
	deleteItem: (CASES, res) => ((res.status === StatusCodes.OK) ?
		{
			type: CASES.DELETE,
			identifier: res.data.identifier,
		} : {
			type: GLOBALS.DEAD_END
		}
	),
	deleteUserFrom: (CASES, res) => ((res.status === StatusCodes.OK) ?
		{
			type: CASES.DELETE_USER_FROM,
			identifier: res.data.identifier,
		} : {
			type: GLOBALS.DEAD_END
		}
	),
	setActive: (CASES, id, params) => ({
		type: CASES.SET_ACTIVE,
		[params.itemId]: id,
	}),
	unsetActive: (CASES) => ({
		type: CASES.UNSET_ACTIVE,
	}),
};